module.exports = __webpack_public_path__ + "assets/img/yonghu.a30f3b2d.png";